import script from "./ClockControl.vue?vue&type=script&lang=ts"
export * from "./ClockControl.vue?vue&type=script&lang=ts"

export default script